import { RootState } from '../store'
import { notificationsMessages } from './reducer'

// Lazily memoized, to avoid circular import.
const createSelectors = () => notificationsMessages.getSelectors()
let notificationSelectors: ReturnType<typeof createSelectors>
const getSelectors = () => (notificationSelectors ??= createSelectors())

export const getNotifications = (state: RootState) =>
  getSelectors().selectAll(state.notifications)
